import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ApiTask } from "src/api/types";
import Button from "src/components/Button";
import useDelete from "src/hooks/rest/useDelete";
import useAlert from "src/hooks/useAlert";

type DeleteTaskButtonProps = {
	task: ApiTask;
};

const DeleteTaskButton = ({ task }: DeleteTaskButtonProps) => {
	const { t } = useTranslation("tasks", {
		keyPrefix: "delete-task",
	});
	const [deleteTask, loading] = useDelete(`/company/tasks/${task.id}`);
	const navigate = useNavigate();
	const [sendAlert] = useAlert();
	const onClick = () => {
		sendAlert({
			title: t("confirm.title"),
			text: t("confirm.description", {
				title: task.title,
			}),
			type: "confirm",
			onConfirm: () => {
				deleteTask().then(() => {
					navigate("/tasks");
				});
			},
		});
	};

	return (
		<Button {...{ loading, onClick }} type="outlined">
			{t("label")}
		</Button>
	);
};

export default DeleteTaskButton;
